import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  flex-direction: column;
  display: flex;
  height: 100%;
`;
export const ContainerCategory = styled.div`
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const Left = styled.img`
  cursor: pointer;
`;
interface IItem {
  active: boolean;
}
export const Bottom = styled.div`
  display: flex;
  justify-self: flex-end;
  align-items: center;
  justify-content: flex-end;
  align-self: flex-end;
`;
export const Title = styled.p`
  color: ${beam.font.primary};
  flex: 1;
  margin-bottom: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
`;
export const TitleWhite = styled(Title)`
  color: #758ca3;
`;
export const Head = styled.p`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  margin: 0;
  color: #1a1b1c;
`;

export const Close = styled.button`
  cursor: pointer;
  font-size: 14px;
  margin-right: 20px;
  border: none;
  background: transparent;
`;
export const Name = styled.input`
  border: 1px solid ${beam.background.card};
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  width: 100%;
  color: ${beam.placeholder.primary};
  min-height: 32px;
  display: flex;
  padding-left: 14px;
  flex: 1;
  padding-right: 14px;
  -webkit-appearance: none;
  margin-bottom: 16px;

  ::placeholder {
    color: ${beam.placeholder.primary};
  }
`;
export const Description = styled.textarea`
  min-height: 100px;
  border: 1px solid ${beam.background.card};
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  width: 100%;
  color: ${beam.placeholder.primary};
  display: flex;
  flex: 1;
  padding-top: 8px;
  padding-left: 14px;
  padding-right: 14px;
  -webkit-appearance: none;
  margin-bottom: 16px;
`;

export const BottomText = styled.button`
  color: ${beam.color.primaryBlue};
  font-size: 14px;
  border: none;
  background: transparent;
  :disabled {
    cursor: auto;
    opacity: 0.3;
  }
`;
export const Block = styled.div`
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 0 8px 8px 0;
  position: absolute;
  top: 0;
  right: -308px;
  width: 308px;
  height: 498px;
  z-index: 11;
`;
export const Item = styled.div<IItem>`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background: ${({ active }) => (active ? '#F6F8FF' : '#fff')};
  cursor: pointer;
`;
export const ItemList = styled.div`
  display: grid;
  cursor: pointer;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 16px;
`;

interface IItemListText {
  active: boolean;
}

export const ItemListText = styled.div<IItemListText>`
  font-size: 14px;
  flex: 1;
  margin-bottom: 16px;
  color: ${({ active }) => (active ? '#1371FE' : '#1a1b1c')};
  overflow: hidden;
`;

export const CategoryText = styled.p<IItemListText>`
  font-size: 14px;
  flex: 1;
  margin-bottom: 8px;
  font-style: normal;
  font-weight: ${({ active }) => (active ? 'normal' : '500')};
  line-height: 21px;
  overflow: hidden;
  cursor: pointer;
  color: ${({ active }) => (active ? '#1371FE' : '#1a1b1c')};
`;
export const CategorySubText = styled.p<IItemListText>`
  flex: 1;
  margin-bottom: 8px;
  font-style: normal;
  cursor: pointer;
  font-weight: 300;
  overflow: hidden;
  font-size: 12px;
  line-height: 18px;
  white-space: break-spaces;

  /* beam texts/default-black */
  color: #1a1b1c;
`;
export const CategoryTextLink = styled.p`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 0px;
  color: #1371fe;
  width: 100%;
  justify-content: flex-end;
`;
export const ItemText = styled.div`
  color: #1a1b1c;
  font-size: 16px;
  flex: 1;
`;
export const Back = styled.div`
  height: 16px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height */

  /* beam texts/default-black */
  color: #1a1b1c;
`;
